import React from 'react';
import {useFormContext} from 'react-hook-form';

export const useEnsureFieldValue = () => {
   const hookFormMethods = useFormContext();

   // return hookFormMethods?.setValue;

   const setValue = React.useCallback(
      (name: string, value: any) => {
         hookFormMethods?.register(name);
         hookFormMethods?.resetField(name, {
            keepDirty: true,
            keepError: true,
            keepTouched: true,
            defaultValue: value,
         });
      },
      [hookFormMethods?.resetField]
   );
   return setValue;
};
